import React from "react";
import "../../styles/modal.css";

// A modal variant for forms: no default footer button; allows custom footer.
function FormModal({
  open,
  title = "Modal",
  children,
  onCancel,
  footer = null,
  size = "default",
  // Optional extra class on the panel, for dialogs that need to own their own
  // scrolling (e.g. a long picker list that should scroll while the header and
  // footer stay put). Purely additive — omitting it keeps the default shell.
  className = "",
}) {
  if (!open) return null;
  const panelClassName = `modal-panel ${
    size === "compact" ? "modal-panel-compact"
    : size === "large" ? "modal-panel-large"
    : ""
  } ${className}`.trim();
  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true">
      <div className={panelClassName}>
        <div className="modal-header">
          <h3 className="modal-title">{title}</h3>
        </div>
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
}

export default FormModal;
